import Building from './Building';

export default Building;



// WEBPACK FOOTER //
// ./src/containers/ClientBuilding/index.js